import React,{ Fragment } from 'react'
import Footer from '../../Components/Footer/Footer'
import Signup from '../../Components/Signup/Signup'

function SignupPage() {
  return (
    <Fragment>
        <Signup/>
        <Footer/>
    </Fragment>
  )
}

export default SignupPage